<template>
  <div style="background-color: black">
    <div class="head">
      <h1>
        <a href="#"></a>
        <!-- <a href="#">顶峰数据可视化</a> -->
      </h1>
    </div>

    <div style="width: 100%; margin: 0 auto">
      <div
        style="
          width: calc(100% - 30px);
          margin: 0 auto;
          height: 280px;
          display: flex;
          gap: 15px;
          margin-top: 15px;
          justify-content: center;
        "
      > 
        <div class="boxall" style="padding: 15px">
          <div
            style="
              height: 100%;
              width: 300px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: rgba(21, 45, 103, 0.4);
            "
          >
            <ul class="zjyl">
              <li>
                <i>14197421<em>个</em></i
                ><span>总量</span>
              </li>
              <li>
                <i>1423412<em>个</em></i
                ><span>已生产数量</span>
              </li>
              <li>
                <i>129018<em>个</em></i
                ><span>今日生产量</span>
              </li>
            </ul>
          </div>
          <div class="boxfoot"></div>
        </div>
        <div class="boxall" style="padding: 15px">
          <div
            class="boxnav"
            style="
              height: 100%;
              width: 300px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: rgba(21, 45, 103, 0.4);
            "
          >
            <ul class="zjyl">
              <li>
                <i>14197421<em>个</em></i
                ><span>总量</span>
              </li>
              <li>
                <i>1423412<em>个</em></i
                ><span>已生产数量</span>
              </li>
              <li>
                <i>129018<em>个</em></i
                ><span>今日生产量</span>
              </li>
            </ul>
          </div>
          <div class="boxfoot"></div>
        </div>

        <div class="boxall" style="padding: 15px">
          <div
            class="boxnav"
            style="
              height: 100%;
              width: 300px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: rgba(21, 45, 103, 0.4);
            "
          >
            <ul class="zjyl">
              <li>
                <i>14197421<em>个</em></i
                ><span>总量</span>
              </li>
              <li>
                <i>1423412<em>个</em></i
                ><span>已生产数量</span>
              </li>
              <li>
                <i>129018<em>个</em></i
                ><span>今日生产量</span>
              </li>
            </ul>
          </div>
          <div class="boxfoot"></div>
        </div>

        <div
          class="boxall"
          style="
            width: calc(100% - 900px);
            background: rgba(21, 45, 103, 0.4);
            padding: 15px;
          "
        >
          <div class="boxfoot"></div>
          <div
            id="main"
            style="
              width: calc(100% - 30px);
              height: 100%;
              background: rgba(21, 45, 103, 0.4);
            "
          ></div>
        </div>
      </div>

      <div
        style="
          margin: 0 auto;
          width: calc(100% - 30px);
          height: 330px;
          display: flex;
          gap: 15px;
          margin-top: 15px;
          justify-content: center;
        "
      >
        <div class="boxall" style="width: 750px; padding: 15px">
          <div
            id="testcontinuousdemo"
            style="
              height: 100%;
              width: 700px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background-color: rgba(21, 45, 103, 0.4);
            "
          ></div>
          <div class="boxfoot"></div>
        </div>

        <div
          class="boxall"
          style="
            width: calc(100% - 800px);
            height: 330px;
            background: rgba(21, 45, 103, 0.4);
          "
        >
          <div class="boxfoot"></div>
          <div
            id="testPie"
            style="
              height: 300px;
              width: calc(100% - 30px);
              background: rgba(21, 45, 103, 0.4);
            "
          ></div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          height: 280px;
          display: flex;
          gap: 15px;
          margin-top: 15px;
          justify-content: center;
        "
      >
        <div
          class="boxall"
          style="
            width: calc(100% - 30px);
            height: 330px;
            background: rgba(21, 45, 103, 0.4);
          "
        >
          <div class="boxfoot"></div>

          <div
            id="testdemo"
            style="
              width: calc(100% - 30px);
              height: 300px;
              background: rgba(21, 45, 103, 0.4);
            "
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  createApp,
  ref,
  onMounted,
  onBeforeMount,
  onUpdated,
  onBeforeUpdate,
  onBeforeUnmount,
  onUnmounted,
  onErrorCaptured,
} from "vue";

onBeforeMount(() => {
  console.log("onBeforeMount");
});

onMounted(() => {
  test();
  testdemo();
  testPie();
  testcontinuousdemo();
});

onBeforeUpdate(() => {
  console.log("onBeforeUpdate");
});

onUpdated(() => {
  console.log("onUpdated");
});

onBeforeUnmount(() => {
  console.log("onBeforeUnmount");
});

onUnmounted(() => {
  console.log("onUnmounted");
});

onErrorCaptured((err, instance, info) => {
  console.error("onErrorCaptured", err, instance, info);
  return false; // Prevent default behavior and stop propagation
});

// 定义方法
const test = () => {
  // 基于准备好的dom，初始化echarts实例
  var myChart = echarts.init(document.getElementById("main"));

  // 指定图表的配置项和数据
  var option = {
    title: {
      text: "不良品走势",
    },
    tooltip: {},
    legend: {
      data: ["销量"],
    },
    xAxis: {
      data: ["衬衫", "羊毛衫", "雪纺衫", "裤子", "高跟鞋", "袜子"],
    },
    yAxis: {},
    series: [
      {
        name: "销量",
        type: "bar",
        data: [5, 20, 36, 10, 10, 20],
      },
    ],
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
};

// 定义方法
const testPie = () => {
  // 基于准备好的dom，初始化echarts实例
  var myChart = echarts.init(document.getElementById("testPie"));
  var option = {
    color: ["#67F9D8", "#FFE434", "#56A3F1", "#FF917C"],
    title: {
      text: "Customized Radar Chart",
    },
    legend: {},
    radar: [
      {
        indicator: [
          { text: "Indicator1" },
          { text: "Indicator2" },
          { text: "Indicator3" },
          { text: "Indicator4" },
          { text: "Indicator5" },
        ],
        center: ["25%", "50%"],
        radius: 120,
        startAngle: 90,
        splitNumber: 4,
        shape: "circle",
        axisName: {
          formatter: "【{value}】",
          color: "#428BD4",
        },
        splitArea: {
          areaStyle: {
            color: ["#77EADF", "#26C3BE", "#64AFE9", "#428BD4"],
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowBlur: 10,
          },
        },
        axisLine: {
          lineStyle: {
            color: "rgba(211, 253, 250, 0.8)",
          },
        },
        splitLine: {
          lineStyle: {
            color: "rgba(211, 253, 250, 0.8)",
          },
        },
      },
      {
        indicator: [
          { text: "Indicator1", max: 150 },
          { text: "Indicator2", max: 150 },
          { text: "Indicator3", max: 150 },
          { text: "Indicator4", max: 120 },
          { text: "Indicator5", max: 108 },
          { text: "Indicator6", max: 72 },
        ],
        center: ["75%", "50%"],
        radius: 120,
        axisName: {
          color: "#fff",
          backgroundColor: "#666",
          borderRadius: 3,
          padding: [3, 5],
        },
      },
    ],
    series: [
      {
        type: "radar",
        emphasis: {
          lineStyle: {
            width: 4,
          },
        },
        data: [
          {
            value: [100, 8, 0.4, -80, 2000],
            name: "Data A",
          },
          {
            value: [60, 5, 0.3, -100, 1500],
            name: "Data B",
            areaStyle: {
              color: "rgba(255, 228, 52, 0.6)",
            },
          },
        ],
      },
      {
        type: "radar",
        radarIndex: 1,
        data: [
          {
            value: [120, 118, 130, 100, 99, 70],
            name: "Data C",
            symbol: "rect",
            symbolSize: 12,
            lineStyle: {
              type: "dashed",
            },
            label: {
              show: true,
              formatter: function (params) {
                return params.value;
              },
            },
          },
          {
            value: [100, 93, 50, 90, 70, 60],
            name: "Data D",
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: "rgba(255, 145, 124, 0.1)",
                  offset: 0,
                },
                {
                  color: "rgba(255, 145, 124, 0.9)",
                  offset: 1,
                },
              ]),
            },
          },
        ],
      },
    ],
  };

  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
};

// 定义方法
const testdemo = () => {
  // 基于准备好的dom，初始化echarts实例
  var myChart = echarts.init(document.getElementById("testdemo"));
  var option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },

    legend: {
      data: ["生产数量", "良品", "不良品"],
    },
    xAxis: [
      {
        type: "category",
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "生产数量",
        min: 0,
        max: 250,
        interval: 50,
        axisLabel: {
          formatter: "{value} 个",
        },
      },
      {
        type: "value",
        name: "良品",
        min: 0,
        max: 25,
        interval: 5,
        axisLabel: {
          formatter: "{value} 个",
        },
      },
    ],
    series: [
      {
        name: "生产数量",
        type: "bar",
        tooltip: {
          valueFormatter: function (value) {
            return value + " 个";
          },
        },
        data: [
          2.0, 4.9, 7.0, 23.2, 25.6, 76.7, 135.6, 162.2, 32.6, 20.0, 6.4, 3.3,
        ],
      },
      {
        name: "不良品",
        type: "bar",
        tooltip: {
          valueFormatter: function (value) {
            return value + " 个";
          },
        },
        data: [
          2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3,
        ],
      },
      {
        name: "良品",
        type: "line",
        yAxisIndex: 1,
        tooltip: {
          valueFormatter: function (value) {
            return value + " 个";
          },
        },
        data: [
          2.0, 2.2, 3.3, 4.5, 6.3, 10.2, 20.3, 23.4, 23.0, 16.5, 12.0, 6.2,
        ],
      },
    ],
  };
  // 使用刚指定的配置项和数据显示图表。
  myChart.setOption(option);
};

// 定义方法
const testcontinuousdemo = () => {
  // 基于准备好的dom，初始化echarts实例
  var myChart = echarts.init(document.getElementById("testcontinuousdemo"));

  var option = {
    title: {
      text: "Stacked Line",
    },
    tooltip: {
      trigger: "axis",
    },
    legend: {
      data: ["Union Ads", "Video Ads", "Direct", "Search Engine"],
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    toolbox: {
      feature: {
        saveAsImage: {},
      },
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    yAxis: {
      type: "value",
    },
    series: [
      {
        name: "Union Ads",
        type: "line",
        stack: "Total",
        data: [220, 182, 191, 234, 290, 330, 310],
      },
      {
        name: "Video Ads",
        type: "line",
        stack: "Total",
        data: [150, 232, 201, 154, 190, 330, 410],
      },
      {
        name: "Direct",
        type: "line",
        stack: "Total",
        data: [320, 332, 301, 334, 390, 330, 320],
      },
      {
        name: "Search Engine",
        type: "line",
        stack: "Total",
        data: [820, 932, 901, 934, 1290, 1330, 1320],
      },
    ],
  };
  myChart.setOption(option);
};
</script>

<style scoped>
.my-component {
  text-align: center;
  margin-top: 20px;
}

.head {
  height: 70px;
  background: url(../assets/images/head_bg.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  display: flex;

  align-items: center;
  justify-content: center;
}
.head h1 {
  color: #bde4ff;
  font-weight: bolder;
  letter-spacing: 2px;
  font-size: 18pt;
}
.head h1 img {
  width: 30px;
  display: inline-block;
}

.boxall {
  border: 1px solid rgba(103, 144, 255, 0.1);
  background: rgba(21, 45, 103, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 10;
}
.boxall:before,
.boxall:after {
  position: absolute;

  content: "";
  border-top: 3px solid #3486da;
  top: -2px;
  width: 30px;
  height: 30px;
}
.boxall:before,
.boxfoot:before {
  border-left: 3px solid #3486da;
  left: -2px;
  width: 30px;
  height: 30px;
}
.boxall:after,
.boxfoot:after {
  border-right: 3px solid #3486da;
  right: -2px;
  width: 30px;
  height: 30px;
}

.zjyl {
  width: 100%;
}
.zjyl li {
  float: left;
  width: 100%;
  text-align: center;
  padding: 5px;
  position: relative;
  border-right: 1px solid rgba(103, 144, 255, 0.1);
}

.zjyl li i {
  font-size: 15pt;
  font-family: electronicFont;
  color: #fff32b;
  display: block;
}
.zjyl li i em {
  font-size: 25px;
  color: #fff;
  opacity: 0.5;
}
.zjyl li span {
  font-size: 20px;
  font-weight: lighter;
  color: red;
}

.boxfoot {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
}
.boxfoot:before,
.boxfoot:after {
  position: absolute;
  width: 30px;
  height: 30px;
  content: "";
  border-bottom: 3px solid #3486da;
  bottom: -2px;
}
</style>
